export const MOST_ACTIVE_LIST_REQ = 'MOST_ACTIVE_LIST_REQ'
export const MOST_ACTIVE_LIST_SUCCESS = 'MOST_ACTIVE_LIST_SUCCESS'
export const MOST_ACTIVE_LIST_ERROR = 'MOST_ACTIVE_LIST_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/statistics/most-active.type.js